import { render, staticRenderFns } from "./news14.vue?vue&type=template&id=6b379a98&scoped=true&"
import script from "./news14.vue?vue&type=script&lang=js&"
export * from "./news14.vue?vue&type=script&lang=js&"
import style0 from "./news14.vue?vue&type=style&index=0&id=6b379a98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b379a98",
  null
  
)

export default component.exports